import { render, staticRenderFns } from "./fourIndex.vue?vue&type=template&id=9f9c82c6&scoped=true"
import script from "./fourIndex.vue?vue&type=script&lang=js"
export * from "./fourIndex.vue?vue&type=script&lang=js"
import style0 from "./fourIndex.vue?vue&type=style&index=0&id=9f9c82c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f9c82c6",
  null
  
)

export default component.exports